<form [formGroup]="bundleForm">
  <div class="row mb-2">
    <div class="col-12">
      <div class="row">
        <div class="col-12 col-md-7">
          <input
            #bundleTypeaheadElement
            type="text"
            #instance="ngbTypeahead"
            class="form-control mb-2"
            container="body"
            [placeholder]="
              'pricing.partner.details.placeholders.bundle' | translate
            "
            [resultTemplate]="itemTemplate"
            [inputFormatter]="inputFormatter"
            [ngbTypeahead]="search"
            [disabled]="bundleTypeaheadDisabled()"
            (selectItem)="bundleForm.get('bundle').setValue($event.item)"
            (focus)="focus$.next($event.target.value)"
            (click)="click$.next($event.target.value)"
          />

          <ng-template #itemTemplate let-r="result" let-t="term">
            <ngb-highlight [result]="r.internalName" [term]="t"></ngb-highlight>
          </ng-template>
        </div>
        <div class="col-5 col-md-2">
          <input
            ngbDatepicker
            class="form-control"
            id="validFrom"
            formControlName="validFrom"
            appInputValidationStatus
            container="body"
            #validFromDatepicker="ngbDatepicker"
            data-cy="date-of-birth-input"
            [readonly]="true"
            [minDate]="momentToNgbDate(minDate)"
            [maxDate]="momentToNgbDate(maxDate)"
            [startDate]="momentToNgbDate(startDate)"
            [placeholder]="
              'serviceData.form.placeholders.dateFormat' | translate
            "
            (click)="validFromDatepicker.toggle()"
          />
        </div>
        <div class="col-5 col-md-2">
          <input
            type="number"
            class="form-control"
            formControlName="price"
            [placeholder]="
              'pricing.partner.details.placeholders.price' | translate
            "
          />
        </div>
        <div class="col-2 col-md-1">
          <button
            class="icon-btn icon-btn-lg"
            triggers="hover"
            placement="top"
            [ngbTooltip]="'pricing.partner.details.addPriceTooltip' | translate"
            [disabled]="bundleForm.invalid"
            (click)="addBundle()"
          >
            <i class="fa-light fa-plus"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="offset-5 offset-md-9 col-5 col-md-2">
          <app-validation-error for="price" translations="validation.generic" />
        </div>
      </div>
      @if (noCurrencyWarning()) {
        <div class="row">
          <div class="col-12 my-2">
            <div class="notes">
              {{ 'pricing.partner.details.noCurrencyWarning' | translate }}
            </div>
          </div>
        </div>
      } @else if (firstTimePrice()) {
        <div class="row">
          <div class="col-12 my-2">
            <div class="notes">
              {{ 'pricing.partner.details.priceWarning' | translate }}
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</form>
